// src/store/services/coach.js
import feathersClient, {
  makeServicePlugin,
  BaseModel
} from "../../feathers-client";

class EndorsementInvitePrgms extends BaseModel {
  constructor (data, options) {
    super(data, options);
  }
  // Required for $FeathersVuex plugin to work after production transpile.
  static modelName = "EndorsementInvitePrgms";
  // Define default properties here
  static instanceDefaults () {
    return {
      id: null,
      progressMeasureId: null,
      endorsementInviteId: null
    };
  }
}
const servicePath = "endorsement-invite-prgms";
const servicePlugin = makeServicePlugin({
  Model: EndorsementInvitePrgms,
  service: feathersClient.service(servicePath),
  servicePath
});

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
});

export default servicePlugin;
